import React from "react";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import { attendeeActions } from "../../../../store/actions/attendee/attendee.action";
import { formActions } from "../../../../store/actions/cms/form/form.action";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import { IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, ListSubheader, Button as MuiButton, Tooltip } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import Badge from "@material-ui/core/Badge";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -3,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}))(Badge);

export const FloatingCartButton = ({ attendee, dispatch }) => {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <div
        style={{
          position: "fixed",
          left: 10,
          bottom: 10,
        }}
      >
        <IconButton onClick={handleClickOpen} style={{ borderRadius: 15, background: "#fff", padding: 20 }}>
          <StyledBadge badgeContent={attendee?.orders?.length || 1} color="error">
            <PersonIcon />
          </StyledBadge>
        </IconButton>
      </div>
      <div>
        <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
          <DialogTitle id="responsive-dialog-title" style={{ padding: "10px 16px 0px 16px" }}>
            <SystemLabel name="MyOrders" />
          </DialogTitle>
          <DialogContent style={{ padding: "0px 15px" }} className="jir-dialog-content">
            <DialogContentText>
              <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                subheader={
                  <ListSubheader component="div" style={{ padding: 0 }} id="nested-list-subheader">
                    <SystemLabel name="EditOrDeletePersons" />
                  </ListSubheader>
                }
              >
                {attendee.orders.map((o, i) => {
                  console.log(o)
                  return (
                    <ListItem key={i} style={{ paddingLeft: 0 }}>
                      <ListItemIcon>
                        <AccountCircleIcon />
                      </ListItemIcon>
                      <ListItemText primary={o?.person?.firstName + " " + o?.person?.lastName}  />
                      <ListItemSecondaryAction>
                        <IconButton
                          onClick={() => {
                            dispatch(attendeeActions.setActivePersonNo(i));
                            handleClose();
                          }}
                        >
                          <Tooltip title={<SystemLabel name="EditPerson" />}>
                            <CreateIcon />
                          </Tooltip>
                        </IconButton>
                        {!o.orderId ? (
                          <IconButton disabled={attendee.orders.length == 1} onClick={() => dispatch(attendeeActions.removeOrder(i))}>
                            <Tooltip title={<SystemLabel name="Delete" />}>
                              <DeleteIcon />
                            </Tooltip>
                          </IconButton>
                        ) : null}
                        {attendee.orders.length > 1 ? (
                          <IconButton
                            style={{ opacity: o.leader == true || (o.orderId == o.orderGroupId && attendee.orders.filter((o) => o.leader == true).length == 0) ? 1 : 0.5 }}
                            onClick={() => dispatch(attendeeActions.setLeader(i))}
                          >
                            <Tooltip title={<SystemLabel name="MakeGroupLeader" />}>
                              <VerifiedUserIcon />
                            </Tooltip>
                          </IconButton>
                        ) : null}
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                })}

                {/*   <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItem button className={classes.nested}>
                    <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon>
                    <ListItemText primary="Starred" />
                  </ListItem>
                </List>
              </Collapse> */}
              </List>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <MuiButton onClick={handleClose} autoFocus>
              <SystemLabel name="Close" />
            </MuiButton>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

const GroupRegistration = (props) => {
  const { dispatch, cms, element, allowAdd } = props;
  const { button } = props.template;
  return (
    <>
      <Button
        style={{ backgroundColor: button.backgroundColor, color: button.color, fontFamily: button.fontFamily, marginLeft: 10, borderRadius: 5 }}
       /*  disabled={allowAdd()} */
        onClick={() => {
          if (allowAdd()) {
            dispatch(attendeeActions.createOrder({}));
            dispatch(formActions.scrollPage(element.data.returnPage || 1));
          }
        }}
      >
        <PersonAddIcon />
        <SystemLabel name="AddOrder" />
      </Button>
    </>
  );
};

function mapStateToProps(state) {
  return {
    cms: state.cms,
    attendee: state.attendee,
    template: state.template && state.template.template ? state.template.template.content : {},
  };
}
export default connect(mapStateToProps)(GroupRegistration);
